export const GET_SHARED_POSTS_IN_SOCIAL_MEDIA = 'GET_SHARED_POSTS_IN_SOCIAL_MEDIA';
export const SET_SHARED_POSTS_IN_SOCIAL_MEDIA = 'SET_SHARED_POSTS_IN_SOCIAL_MEDIA';
export const GET_SHARED_POSTS_IN_SOCIAL_MEDIA_ERROR = 'GET_SHARED_POSTS_IN_SOCIAL_MEDIA_ERROR';
